import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/not-found.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedLogo"] */ "/app/src/components/AnimatedLogo/AnimatedLogo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button/Button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/app/src/components/Nav/Nav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/css/main.css");
